<template> 
  <div class="evento-wrapper" ref="wrapperRef">

    <!-- Fondo -->
    <img
      :src="require('@/assets/F1.jpg')"
      alt="Fondo"
      class="fondo-textura"
    />

    <!-- Ramita decorativa -->
    <img
      src="@/assets/ramita.avif"
      alt="Decoración"
      class="ramita-fondo-visual"
    />

    <!-- TARJETA -->
    <div ref="ceremoniaRef" class="tarjeta-evento derecha reveal">

      <p ref="tituloRef" class="titulo-evento">
        Ceremonia y Recepción
      </p>

      <div class="separator-holder reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <p ref="direccionRef" class="direccion">
        <img
          src="@/assets/mapas.png"
          alt="Mapa"
          class="icono-mapa"
        />

        Villa el Guano <br />
      </p>

      <!-- 🔥 DIRECCIÓN CON ADHOC -->
      <p ref="direccionAdhocRef" class="direccion-adhoc">
        Avenida Francisco Alberto Caamaño Deñó Pekín;<br>
        Calle Los Jazmines Santiago de los Caballeros
      </p>
<br />
      <!-- Carrusel -->

      <p ref="horaRef" class="hora">
        4:00 PM
      </p>

      <a
        ref="botonRef"
        class="boton-mapa"
        href="https://maps.app.goo.gl/Y5nwVQ2R4QEYzfVU7?g_st=iw"
        target="_blank"
      >
        Ver mapa
      </a>

    </div>

    <!-- DRESSCODE -->
    <div ref="dressCodeRef" class="dresscode-box reveal">

      <p class="dresscode-title">
        Código de vestimenta
      </p>

      <div class="separator-holder mini reveal">
        <img
          :src="require('@/assets/separadorr.png')"
          alt="Separador"
          class="separador-img"
        />
      </div>

      <p class="dresscode-text">
        El blanco es un color hermoso, pero en esta ocasión es exclusivo para la Novia.
        <br><br>
        Evitar colores estampados.
      </p>

      <!-- 🔥 PALETA -->
      <div ref="paletaRef" class="paleta-box">
        <img
          :src="require('@/assets/paleta.png')"
          alt="Paleta"
          class="paleta-img"
        />
      </div>

    </div>

  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'EventoDoble',

  setup() {

    const wrapperRef = ref(null)

    const ceremoniaRef = ref(null)
    const ramitaRef = ref(null)

    const tituloRef = ref(null)
    const lugarRef = ref(null)
    const direccionRef = ref(null)
    const direccionAdhocRef = ref(null)

    const fotoRef = ref(null)
    const horaRef = ref(null)
    const botonRef = ref(null)
    const dressCodeRef = ref(null)

    const paletaRef = ref(null)

    const imagenesLugar = [
      require('@/assets/lugar.jpg'),
      require('@/assets/lugar3.jpg'),
      require('@/assets/lugar4.jpg'),
      require('@/assets/lugar5.jpg')
    ]

    const fotoActual = ref(0)

    onMounted(() => {

      const observer = new IntersectionObserver((entries)=>{

        entries.forEach((entry)=>{

          if(entry.isIntersecting){

            entry.target.classList.add('visible')

          }

        })

      }, { threshold: 0.15 })

      document.querySelectorAll('.reveal').forEach(el=>{
        observer.observe(el)
      })

      setInterval(() => {

        fotoActual.value =
        (fotoActual.value + 1) % imagenesLugar.length

      }, 2000)

      /* 🔥 GSAP DIRECCIÓN */

      gsap.fromTo(
        direccionAdhocRef.value,
        {
          opacity:0,
          y:40,
          scale:.9
        },
        {
          opacity:1,
          y:0,
          scale:1,
          duration:1.4,
          ease:'power3.out',
          scrollTrigger:{
            trigger:direccionAdhocRef.value,
            start:'top 85%'
          }
        }
      )

      gsap.to(
        direccionAdhocRef.value,
        {
          y:'-=6',
          duration:2.5,
          repeat:-1,
          yoyo:true,
          ease:'sine.inOut'
        }
      )

      /* 🔥 GSAP PALETA */

      gsap.fromTo(
        paletaRef.value,
        {
          opacity:0,
          y:50,
          scale:.7,
          rotate:-8
        },
        {
          opacity:1,
          y:0,
          scale:1,
          rotate:0,
          duration:1.6,
          delay:.4,
          ease:'back.out(1.8)',
          scrollTrigger:{
            trigger:paletaRef.value,
            start:'top 90%'
          }
        }
      )

      gsap.to(
        paletaRef.value,
        {
          y:'-=10',
          duration:2.8,
          repeat:-1,
          yoyo:true,
          ease:'sine.inOut'
        }
      )

    })

    return {
      wrapperRef,
      ceremoniaRef,
      ramitaRef,
      tituloRef,
      lugarRef,
      direccionRef,
      direccionAdhocRef,
      fotoRef,
      horaRef,
      botonRef,
      dressCodeRef,
      paletaRef,
      imagenesLugar,
      fotoActual
    }
  }
}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Poppins:wght@300;400;500&display=swap');

/* ========= CONTENEDOR ========= */

.evento-wrapper{
  position:relative;
  width:100%;
  padding:120px 0px;
  overflow:hidden;

  display:flex;
  flex-direction:column;
  align-items:center;
}

/* ========= FONDO ========= */

.fondo-textura{
  position:absolute;
  inset:0;
  width:100%;
  height:100%;
  object-fit:cover;
  z-index:0;
}

/* ========= RAMITAS ========= */

.ramita-fondo-visual{
  position:absolute;
  top:-120px;
  left:0;
  width:100%;
  opacity:.05;
  z-index:1;
  pointer-events:none;
}

.ramita-decorativa{
  width:90px;
  margin-top:40px;
  opacity:.7;
  z-index:2;
}

/* ========= TARJETA ========= */

.tarjeta-evento{
  position:relative;
  z-index:2;

  width:100%;
  max-width:390px;

  padding:50px 28px;

  text-align:center;

  border-radius:40px;

  background:rgba(255,255,255,.72);

  backdrop-filter:blur(4px);

  box-shadow:
  0 10px 40px rgba(0,0,0,.10);
}

/* ========= TITULO ========= */

.titulo-evento{
  font-family:'Playfair Display', serif;
  font-size:38px;
  line-height:1.3;
  color:#b08a5a;
  margin-bottom:10px;
}

/* ========= TEXTO ========= */

.lugar{
  font-family:'Playfair Display', serif;
  font-size:22px;
  line-height:1.8;
  color:#6f6660;
  margin-top:18px;
}

.direccion{
  font-family:'Poppins', sans-serif;
  font-size:14px;
  line-height:1.9;
  color:#8f847c;
  letter-spacing:.08em;
  top:20px !important;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:10px;
}

/* 🔥 DIRECCIÓN ADHOC */

.direccion-adhoc{
  margin-top:14px;

  font-family:'Playfair Display', serif !important;
  font-size:13px !important;

  line-height:1.5;

  color:#9b7b56;

  text-align:center;

  letter-spacing:.03em;
  margin-top:-20px;

  padding:0 12px;
}

.hora{
  margin-top:18px;

  font-family:'Playfair Display', serif;
  font-size:28px;
  color:#b08a5a;

  letter-spacing:.12em;
}

/* ========= BOTON ========= */

.boton-mapa{
  display:inline-block;

  margin-top:24px;

  padding:12px 28px;

  border-radius:999px;

  background:#8e6f49;

  color:#f7f7f7;

  text-decoration:none;

  font-family:'Poppins', sans-serif;
  font-size:13px;
  letter-spacing:.12em;
  text-transform:uppercase;

  box-shadow:
  0 8px 20px rgba(0,0,0,.08);

  transition:.35s ease;
}

.boton-mapa:hover{
  transform:translateY(-4px);
}

/* ========= CARRUSEL ========= */

.carrusel-fotos{
  width:100%;
  max-width:290px;
  height:190px;

  margin:30px auto 0;

  border-radius:26px;
  overflow:hidden;

  box-shadow:
  0 10px 24px rgba(0,0,0,.10);
}

.carrusel-fotos img{
  width:100%;
  height:100%;
  object-fit:cover;
  transition:opacity .5s ease;
}

/* ========= DRESSCODE ========= */

.icono-mapa{
  width:40px;
  height:40px;
  object-fit:contain;
}

.dresscode-box{
  position:relative;
  z-index:2;

  margin-top:34px;

  width:100%;
  max-width:340px;

  padding:34px 24px;

  text-align:center;

  border-radius:30px;

  background:rgba(255,255,255,.72);

  backdrop-filter:blur(4px);

  box-shadow:
  0 10px 30px rgba(0,0,0,.08);
}

.dresscode-title{
  font-family:'Playfair Display', serif;
  font-size:30px;
  color:#b08a5a;
}

.dresscode-text{
  margin-top:10px;

  font-family:'Playfair Display', serif;
  font-size:20px;
  line-height:1.9;

  color:#6f6660;
}

/* 🔥 PALETA */

.paleta-box{
  margin-top:-64px !important;
margin-bottom: 50px !important;
  width:100%;

  display:flex;
  justify-content:center;
}

.paleta-img{
  width:220px;

  height:auto;

  object-fit:contain;

  display:block;
}

/* ========= SEPARADORES ========= */

.separator-holder{
  display:flex;
  justify-content:center;
  margin:20px 0;
}

.separator-holder.mini{
  margin:12px 0;
}

.separador-img{
  width:80%;
  opacity:.9;
}

/* ========= ANIMACIONES ========= */

.reveal{
  opacity:0;
  transform:translateY(45px);
  transition:all 1.2s ease;
}

.reveal.visible{
  opacity:1;
  transform:translateY(0);
}

/* ========= RESPONSIVE ========= */

@media(max-width:768px){

  .evento-wrapper{
    padding:90px 18px;
  }

  .titulo-evento{
    font-size:32px;
  }

  .lugar{
    font-size:19px;
  }

  .direccion-adhoc{
    font-size:22px;
    line-height:1.6;
  }

  .dresscode-title{
    font-size:26px;
  }

  .dresscode-text{
    font-size:18px;
  }

  .paleta-img{
    width:180px;
  }

}

</style>